import { Link } from "react-router-dom";
import { Anchor, Breadcrumbs } from "@mantine/core";

import { ADMIN_NAV_BINGO } from "_constants";
import { ADMIN_PATH } from "_urls";

export function BingoBreadcrumbs() {
  return (
    <Breadcrumbs separator="→">
      <Anchor component={Link} to={`/${ADMIN_PATH}`}>
        Admin
      </Anchor>

      <span>{ADMIN_NAV_BINGO}</span>
    </Breadcrumbs>
  );
}
